import * as React from 'react';
import { Processing } from '@wg/wows-react-uikit';
import { useDispatch } from 'react-redux';
import { setFullscreen } from '~/Actions/ActionApp';
import { setScrollover } from '~/api/WoWsClient';

interface IContainerLazyContainer<T extends React.LazyExoticComponent<React.FC<any>>> {
    Container: T;
    Fallback?: T;
    category: IMenuMapItem;
}

const CategoryLazyContainer = ({ Container, Fallback, category }: IContainerLazyContainer<any>) => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setFullscreen(true));
        setScrollover(true);

        return () => {
            dispatch(setFullscreen(false));
            setScrollover(false);
        };
    }, []);

    return (
        <React.Suspense fallback={Fallback ? Fallback : <Processing isFetching />}>
            <Container category={category} />
        </React.Suspense>
    );
};

export default CategoryLazyContainer;
